import type * as React from 'react'

import { cn } from '@nwwp/ui-shadcn/lib/utils'

type HowItWorksStep = {
  title: string
  body: string
  icon?: React.ReactNode
  /** Prefer illustration media. Falls back to `icon` if omitted. */
  media?: React.ReactNode
}

type HowItWorksStepsProps = {
  title?: React.ReactNode
  steps: HowItWorksStep[]
  className?: string
}

function HowItWorksSteps({ title = 'How NerdWallet Wealth Partners works', steps, className }: HowItWorksStepsProps) {
  return (
    <section data-slot="how-it-works-steps" className={cn('flex flex-col gap-8', className)}>
      {title ? <h2 className="text-center text-title-xl text-foreground">{title}</h2> : null}
      <ol className="grid gap-10 tablet:grid-cols-3 tablet:gap-6">
        {steps.map(({ title: stepTitle, body, icon, media }, i) => (
          <li key={`${stepTitle}-${i}`} className="flex flex-col items-center gap-4 text-center">
            {media ? (
              <div className="flex w-full max-w-55 items-center justify-center">{media}</div>
            ) : icon ? (
              <div className="text-primary" aria-hidden>
                {icon}
              </div>
            ) : null}
            <div className="flex flex-col gap-2">
              <h3 className="text-title-lg text-foreground">{stepTitle}</h3>
              <p className="text-body-sm text-muted-foreground">{body}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  )
}

export { HowItWorksSteps }
export type { HowItWorksStepsProps, HowItWorksStep }
